import { useEffect } from 'react';

const defaults = {
  title: 'BORMULA | The Speed of Culture',
  description: 'The fastest source for F1 news, memes, and culture. Next-gen Formula 1 media for the internet-native fan.',
  image: 'https://bormula.com/favicon.svg',
  url: 'https://bormula.com',
  type: 'website',
};

function setMeta(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`) || document.querySelector(`meta[name="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    if (property.startsWith('og:') || property.startsWith('twitter:')) {
      el.setAttribute('property', property);
    } else {
      el.setAttribute('name', property);
    }
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useSEO({ title, description, image, url, type, author } = {}) {
  useEffect(() => {
    const pageTitle = title ? title + ' | BORMULA' : defaults.title;
    document.title = pageTitle;

    setMeta('description', description || defaults.description);
    setMeta('og:title', title || defaults.title);
    setMeta('og:description', description || defaults.description);
    setMeta('og:image', image || defaults.image);
    setMeta('og:url', url || defaults.url);
    setMeta('og:type', type || defaults.type);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title || defaults.title);
    setMeta('twitter:description', description || defaults.description);
    setMeta('twitter:image', image || defaults.image);
    if (author) setMeta('author', author);

    // Set canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url || defaults.url);

    return () => {
      document.title = defaults.title;
    };
  }, [title, description, image, url, type, author]);
}
